var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RaiSetup',{attrs:{"title":_vm.$t('settings.automation.nightlyReports.review.title'),"type":"info","hide-next":""}},[_c('VxFormGroup',{attrs:{"title":_vm.$t('settings.automation.nightlyReports.review.sentEmailGroup.title')}},[_c('ReviewReportList',{attrs:{"reports":_vm.reports}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }